import { Container, Row } from "react-bootstrap";

const PageContact = () => {
  return <Container>
    <Row className="d-flex justify-content-center align-items-center text-center">
      <div className="col-md-6 mb-2">
        <h5>{"España 1025, Rosario, Santa Fe"}</h5>
        <h5>Telefono: 3412470782</h5>
        <h5>newtonclothes18@gmail.com</h5>
        <h1>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://api.whatsapp.com/send?phone=5493412470782"
          >
            <i className="fa fa-whatsapp"></i>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/newton_clothes/"
          >
            <i className="fa fa-instagram"></i>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/newtons84/"
          >
            <i className="fa fa-facebook-square"></i>
          </a>
        </h1>
      </div>
      <div className="col-md-6">
        <iframe
          title="My addrees"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.1178007193075!2d-60.64725791182893!3d-32.94789912872239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab1434d553f7%3A0xdae75cb1e8a97b6e!2sEspa%C3%B1a%201025%2C%20S2000%20Rosario%2C%20Santa%20Fe!5e0!3m2!1ses!2sar!4v1600462900292!5m2!1ses!2sar"
          width="100%"
          height="400"
          style={{ border: 0 }}
        ></iframe>
      </div>
    </Row>
  </Container>
}
export default PageContact
